import './design/theme.css'

import { createApplication } from './bootstrap.js'

/**
 * The entry point, deliberately thin.
 *
 * Composition lives in `bootstrap.ts` so a test can build the application without mounting
 * it, and so this file never grows a conditional.
 *
 * **Mounted without awaiting `ready`.** The router's guard awaits the session itself, so
 * waiting here would hold a blank page for the length of a network round trip — and if that
 * request hangs, hold it indefinitely. Mounting first renders the shell and lets the guard
 * resolve the first navigation when the answer arrives.
 */
const { app } = createApplication()

app.mount('#app')
